/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/prop-types */
/* eslint-disable no-return-assign */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-core-theme/src/hooks/link';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import getTeamLogo from '../../../../helpers/common';
import styles from './leagues.module.scss';

// eslint-disable-next-line react/prop-types
export const DefImg = ({ isStorybook = false, alt = '' }) => (
  <img
    alt={alt}
    src={
      isStorybook ? './flags/european_union.svg' : '../../../../../images/flags/european_union.svg'
    }
    width={36}
    height={36}
  />
);

// eslint-disable-next-line react/prop-types
export const TeamDefImg = ({ isStorybook = false, alt = '' }) => (
  <img
    alt={alt}
    src={isStorybook ? './images/default.svg' : '/images/default.svg'}
    width={36}
    height={36}
  />
);

const Leagues = ({ isStorybook = false, items, template = '' }) => (
  <>
    {items.map((league, index) => (
      <table key={index} className={`${styles.table} ${styles[template]}`}>
        <tbody>
          <tr>
            <td className={styles.league}>
              {league.country_code && (
                <LazyImage
                  src={
                    league.country_code !== 'international' && league.country_code !== 'int'
                      ? `../../../../../images/flags/${league.country_code}.svg`
                      : '../../../../../images/flags/european_union.svg'
                  }
                  alt={league.name}
                  width={36}
                  height={36}
                  defaultImg={<DefImg alt={league.name} isStorybook={isStorybook} />}
                />
              )}
              {league.name}
            </td>
          </tr>
          {league?.events.map((event, index) => (
            <tr key={index}>
              <td className={styles.event}>
                <li>
                  <Link to={event?.path} className="schedule-leagues-gtm image-gtm name-cta">
                    <span className={styles.date}>{` ${event.date.time}`}</span>
                    <span className={styles.teams}>
                      <span className={styles.home}>
                        <span className={styles.teamName}>{` ${event?.home_team?.name}`}</span>
                        <div className={styles.logo}>
                          {event?.home_team?.logo ? (
                            <LazyImage
                              src={getTeamLogo(event?.home_team, isStorybook)}
                              alt={event?.home_team?.name}
                              width={23}
                              height={23}
                              defaultImg={
                                <TeamDefImg
                                  alt={event?.home_team?.name}
                                  isStorybook={isStorybook}
                                />
                              }
                            />
                          ) : (
                            <TeamDefImg isStorybook={isStorybook} />
                          )}
                        </div>
                      </span>
                      <span className={styles.away}>
                        <div className={styles.logo}>
                          {event?.away_team?.logo ? (
                            <LazyImage
                              src={getTeamLogo(event?.away_team, isStorybook)}
                              alt={event?.away_team?.name}
                              width={23}
                              height={23}
                              defaultImg={
                                <TeamDefImg
                                  alt={event?.away_team?.name}
                                  isStorybook={isStorybook}
                                />
                              }
                            />
                          ) : (
                            <TeamDefImg isStorybook={isStorybook} />
                          )}
                        </div>
                        <span className={styles.teamName}>{` ${event.away_team.name}`}</span>
                      </span>
                    </span>
                  </Link>
                </li>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    ))}
  </>
);

Leagues.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  template: PropTypes.string,
};

export default Leagues;
